<!--Navbar Start-->
<nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark" (window:scroll)="windowScroll()" id="navbar">
    <div class="container">
        <!-- LOGO -->
        <a class="navbar-brand logo" href="layout-2">
            <img src="assets/images/logo-dark.png" alt="" class="" height="21">
        </a>
        <button class="navbar-toggler p-0" type="button" data-toggle="collapse" data-target="#navbarCollapse" 
            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleMenu()">
            <i class="mdi mdi-menu"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav ml-auto navbar-center" id="mySidenav">
                <li class="nav-item" [ngClass]="{'active':currentSection === 'home'}">
                    <a [ngxScrollTo]="'#home'" href="javascript: void(0);" class="nav-link">Home</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'services'}">
                    <a [ngxScrollTo]="'#services'" href="javascript: void(0)" class="nav-link" [ngxScrollToOffset]="2">Services</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'about'}">
                    <a [ngxScrollTo]="'#about'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">About</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'features'}">
                    <a [ngxScrollTo]="'#features'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">Features</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'clients'}">
                    <a [ngxScrollTo]="'#clients'" href="javascript: void(0);" class="nav-link" [ngxScrollToOffset]="2">Clients</a>
                </li>
            </ul>
            <div class="call-no">
                <a href="#" class="nav-link text-warning"><i class="mdi mdi-phone mr-1"></i> +00 1234 5678 90</a>
            </div>            
        </div>
    </div>
</nav>
<!-- Navbar End -->

<div appScrollspy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)">
<!-- Hero Start -->
<section class="hero-1-bg position-relative bg-light d-flex align-items-center" id="home">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-title pr-lg-5">
                    <p class="text-uppercase text-primary font-weight-medium f-14 mb-4">Cretive Marketing</p>
                    <h1 class="hero-1-title mb-4 font-weight-normal line-height-1_4">Get Your Professional Website Done With <span class="text-primary font-weight-medium">Deoxa</span></h1>
                    <p class="text-muted mb-4 pb-2">At vero eos et accusamus iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos at dolores molestias excepturi sint occaecati cupiditate.</p>
                    <a href="" class="btn btn-warning">Find Out How <span class="ml-2 right-icon">&#8594;</span></a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="mt-5 mt-lg-0">
                    <img src="assets/images/hero-1-img.png" alt="" class="img-fluid mx-auto d-block">
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Hero End -->
    <app-services></app-services>
    <app-about></app-about>
    <app-features></app-features>
    <app-clients></app-clients>
    <app-contact></app-contact>
    <app-footer></app-footer>
</div>
